export function getBaseApiUrl(): string {
  const { REACT_APP_API_BASEURL }: { REACT_APP_API_BASEURL: string } = (
    window as any
  )["runConfig"];

  return REACT_APP_API_BASEURL;
}
